import { gql } from "@apollo/client";

export const GET_PLANCUIDADO_RENDER_BY_ID = gql`
query PlanCuidadoToRenderById($IdPlanCuidado: Int!){
    planCuidadoToRenderById(planCuidadoId: $IdPlanCuidado) {    
        datosGenerales {
            idPlanCuidado
            idFranjaEtaria
            idComplejidad
            codigoSap
            nombre
            activo
            profesionales
            tm
            envios
            esquema
            idUbicacionPlan
            idReporteVenta
            topeCalPediatrico
            topeCalAdulto
            complejidad
            observacion
            idTipoPlan
            idTipoServicio
            idTipoModulo
            cotizado,
            volumenInicial,
            volumenFinal,
            idModoInfusion
            idPlanCuidadoEstado
          }
          ,
          delegaciones{
            idPlanCuidadoDelegacion
            idPlanCuidado
            idDelegacion
          }
          ,
          clientes{
            idPlanCuidado
            idPlanCuidadoAtributo
            nombre
            codigoSapCliente
            atributo1
            atributo2
            atributo3
            atributo4
            atributo5
            requiereFacturacion
            codigoEspCliente
          },
          documentoLegales{
            idPlanCuidado
            idPlanCuidadoDocumentoLegal
            firmaBloqueaInicio
            bloqueaEnvio
          },
          documentoFacturaciones{
            idDocumentoFac
            idPlanCuidado
            idPlanCuidadoDocumentoFac
          },
          dietas{
                idPlanCuidado
                idPlanCuidadoDieta
                eleccion
          },
          insumos{
            idPlanCuidado,
            idPlanCuidadoInsumo,
            idInsumo,
            cantidad,
            baseCalculo,
            idFranjaEtaria,
            idTipoInsumo,
            idInsumoNavigation{
              idInsumo,
              idInsumoN,
              descripcionGenerica,
              descripcion
            }
          },
          fases{
            idPlanCuidadoFase,
            idPlanCuidado,
            idFase,
            idPlanCuidadoDuracionFase,
            planCuidadoFaseCriterio{
              idCriterio
            }
          },
          profesionales{
            idPlanCuidadoFase,
            idPlanCuidadoFaseProfesional,
            idTipoProfesional,
            idFiguraProfesional,
            idModalidadVisita,
            idModalidadProfesionalCobro,
            idFrecuenciaProfesional,
            orden,
            duracion,
          }
    }
  }
`;